import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

axios.interceptors.response.use(null, error => {
  return Promise.reject(error);
});

const http = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete
};

export const createOrder = data =>
  http.post(`/orders/`, {
    first_name: data.first_name,
    second_name: data.second_name,
    date: data.date,
    location: data.location
  });

export const updateOrder = data =>
  http.put(`/orders/${data.id}`, {
    first_name: data.first_name,
    second_name: data.second_name,
    date: data.date,
    location: data.location,
    template: data.template
  });

export const getOrder = id => http.get(`/orders/${id}`);

export const getUploadUrl = id => http.get(`/orders/${id}/upload`);

export const getStatus = id => http.get(`/orders/${id}/status`);

export const makeOrderPayment = (data, id) =>
  http.post(`/orders/${id}/payment`, data);
